import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=3d15dc5d&"
import script from "./Consent.vue?vue&type=script&lang=js&"
export * from "./Consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports